import React, { useEffect, useRef, ReactNode } from 'react'
import NeshanMapLoader from './neshan-map-loader'
import { polylineEncoded } from './leaflet'

declare global {
    interface Window {
        L: any;
    }
}

export default function NeshanMap(props: { children: ReactNode; style?: {}; options?: { maptype?: string, poi?: boolean, traffic?: boolean, zoomControl?: boolean, center?: [number, number], zoom?: number }; onInit?: (L: any, myMap?: any) => void; }) {
    const { children, style, options, onInit } = props;
    const mapEl: null|any = useRef(null);

    const defaultStyle = {
        width: "600px",
        height: "450px",
        margin: 0,
        padding: 0,
        background: '#eee',
    };

    const defaultOptions = {
        key: process.env.REACT_APP_NESHAN_MAP_WEB_API_KEY || '',
        maptype: 'dreamy',
        poi: true,
        traffic: false,
        center: [Number(process.env.REACT_APP_LAT),Number(process.env.REACT_APP_LNG)],
        zoom: 14,
    };

    useEffect(() => {
        NeshanMapLoader(() => {
            if (mapEl.current && !mapEl.current.hasChildNodes()) {
                let map = new window.L.Map(mapEl.current, { ...defaultOptions, ...options });
                if (onInit)
                    onInit(polylineEncoded(window.L), map);
            }
        }, () => {
                console.error('Neshan Maps Error: This page didn\'t load Neshan Maps correctly');
            });
    }, []);

    return (
        <div ref={mapEl} style={{ ...defaultStyle, ...style }} >
            { children }
        </div>
    );
};
